import React, { useEffect, useRef, useState } from 'react';
import './style.css';

export const Img = ({ id, src, className, alt, onLoad }) => {
  const imgRef = useRef(null);
  const [imageIsReady, setImageIsReady] = useState(false);

  useEffect(() => {
    if (imgRef) {
      let img = new Image();
      img.addEventListener('load', handleOnLoad, false);
      img.src = src;
      imgRef.current.src = img.src;
    }
  }, [src, imgRef]);

  const handleOnLoad = (e) => {
    onLoad(true);
    setImageIsReady(true);
  };

  const checkDisplay = () => {
    if (!imageIsReady) return 'no-display';
    return '';
  };

  return (
    <img
      ref={imgRef}
      id={id}
      className={`img-caption ${className} ${checkDisplay()}`}
      alt={alt}
    />
  );
};
